// reducers/documentReducers.js
import {
    UPLOAD_DOCUMENT_REQUEST,
    UPLOAD_DOCUMENT_SUCCESS,
    UPLOAD_DOCUMENT_FAIL,
    GET_DOCUMENTS_REQUEST,
    GET_DOCUMENTS_SUCCESS,
    GET_DOCUMENTS_FAIL,
    DOWNLOAD_DOCUMENT_REQUEST,
    DOWNLOAD_DOCUMENT_SUCCESS,
    DOWNLOAD_DOCUMENT_FAIL,
    UPDATE_DOCUMENT_REQUEST,
    UPDATE_DOCUMENT_SUCCESS,
    UPDATE_DOCUMENT_FAIL,
    DOCUMENT_UPLOAD_RESET,
    DOCUMENT_UPDATE_RESET,
  } from '../constants/documentConstants';
  
  export const documentUploadReducer = (state = {}, action) => {
    switch (action.type) {
      case UPLOAD_DOCUMENT_REQUEST:
        return { loading: true };
      case UPLOAD_DOCUMENT_SUCCESS:
        return { loading: false, success: true, document: action.payload };
      case UPLOAD_DOCUMENT_FAIL:
        return { loading: false, error: action.payload };
      case DOCUMENT_UPLOAD_RESET: // Handle the reset action
        return {};
      default:
        return state;
    }
  };
  
  export const documentListReducer = (state = { documents: [] }, action) => {
    switch (action.type) {
      case GET_DOCUMENTS_REQUEST:
        return { ...state, loading: true }; // Preserve existing documents while loading
      case GET_DOCUMENTS_SUCCESS:
        return { loading: false, documents: action.payload };
      case GET_DOCUMENTS_FAIL:
        return { loading: false, error: action.payload, documents: state.documents };
      default:
        return state;
    }
  };
  
  export const documentDownloadReducer = (state = {}, action) => {
    switch (action.type) {
      case DOWNLOAD_DOCUMENT_REQUEST:
        return { loading: true };
      case DOWNLOAD_DOCUMENT_SUCCESS:
        return { loading: false, success: true, fileUrl: action.payload };
      case DOWNLOAD_DOCUMENT_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const documentUpdateReducer = (state = {}, action) => {
    switch (action.type) {
      case UPDATE_DOCUMENT_REQUEST:
        return { loading: true };
      case UPDATE_DOCUMENT_SUCCESS:
        return { loading: false, success: true, document: action.payload };
      case UPDATE_DOCUMENT_FAIL:
        return { loading: false, error: action.payload };
      case DOCUMENT_UPDATE_RESET: // Handle the reset action
        return {};
      default:
        return state;
    }
  };